import React, { useContext } from 'react'

const ContactContext = React.createContext({ openContact: () => {} })

export const ContactProvider = ContactContext.Provider

export const useContact = () => {
  return useContext(ContactContext)
}
